// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { MathUtils } from '../MathUtils';
export var IntervalType;
(function (IntervalType) {
    IntervalType[IntervalType["Closed"] = 0] = "Closed";
    IntervalType[IntervalType["RightOpen"] = 1] = "RightOpen";
    IntervalType[IntervalType["LeftOpen"] = 2] = "LeftOpen";
    IntervalType[IntervalType["Open"] = 3] = "Open";
})(IntervalType || (IntervalType = {}));
export var UpDownType;
(function (UpDownType) {
    UpDownType[UpDownType["Up"] = 0] = "Up";
    UpDownType[UpDownType["Down"] = 1] = "Down";
    UpDownType[UpDownType["None"] = 2] = "None";
})(UpDownType || (UpDownType = {}));
export class Intervals {
    constructor(leftValue, rightValue, increment, decimalPlaces, intervalType) {
        // if right value less the left value
        if (rightValue < leftValue) {
            const tmp = leftValue;
            leftValue = rightValue;
            rightValue = tmp;
        }
        this.LeftValue = leftValue;
        this.RightValue = rightValue;
        this.Increment = increment;
        this.DecimalPlaces = decimalPlaces;
        this.IntervalType = intervalType;
    }
    CompareTo(interval) {
        if (interval == null) {
            return -1;
        }
        this.LeftValue.CompareTo(interval.LeftValue);
        if (this.LeftValue > interval.LeftValue) {
            return 1;
        }
        else if (this.LeftValue < interval.LeftValue) {
            return -1;
        }
        else {
            return 0;
        }
    }
    ValueInIntervalUpDown(value, upDown) {
        upDown !== null && upDown !== void 0 ? upDown : (upDown = UpDownType.None);
        switch (upDown) {
            case UpDownType.Down:
                return value > this.LeftValue && value <= this.RightValue;
            case UpDownType.Up:
            default:
                return value >= this.LeftValue && value < this.RightValue;
        }
    }
    ValueInInterval(value) {
        switch (this.IntervalType) {
            case IntervalType.Closed:
                return value >= this.LeftValue && value <= this.RightValue;
            case IntervalType.RightOpen:
                return value >= this.LeftValue && value < this.RightValue;
            case IntervalType.LeftOpen:
                return value > this.LeftValue && value <= this.RightValue;
            case IntervalType.Open:
                return value > this.LeftValue && value < this.RightValue;
            default:
                return false;
        }
    }
    /// <summary>
    /// Метод завел для того чтобы в таблице не было объекта инструмент, в том случае когда используем объект нумерик
    /// maximum - это максимум нумерика, т.к. правая граница у нас должна быть конечным числом
    /// </summary>
    static GetIntervalsFromInstrument(instrument, maximum) {
        const inst = instrument;
        if ((inst === null || inst === void 0 ? void 0 : inst.VariableTickList) == null || inst.VariableTickList.length <= 1) {
            return null;
        }
        const intervals = [];
        for (let i = 1; i < inst.VariableTickList.length; i++) {
            const vt = inst.VariableTickList[i];
            const leftBorder = vt.LeftBorder != 0 ? vt.LeftBorder : vt.PointSize;
            const rightBorder = i + 1 != inst.VariableTickList.length ? vt.RightBorder : maximum;
            const pointSize = vt.PointSize;
            const type = IntervalType.LeftOpen;
            const decimalPlaces = MathUtils.GetDecimalPlaces(pointSize, 20);
            intervals.push(new Intervals(leftBorder, rightBorder, pointSize, decimalPlaces, type));
        }
        return intervals;
    }
}
